import React, {
    useContext,
} from 'react'

import {
    avatar, icon, lightBotStep,
    lightBotWrapper,
} from './styles'

import {EmbedContext} from 'components/EmbedContext'
import {
    NinchatEnvironmentConfig,
} from 'embed/types'

import {NinchatLightBotAvatarIcon} from 'components/Icon'

import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const StyledLightBotStep = styled('div', lightBotStep)
const StyledAvatar = styled('div', avatar)
const StyledLightBotWrapper = styled('div', lightBotWrapper)
const StyledIcon = styled('div', icon)

interface QuestionnaireLightBotProps {
    currentStep: number
    stepsHistory: Array<number>
    questionnaire: NinchatEnvironmentConfig['preAudienceQuestionnaire'] & NinchatEnvironmentConfig['postAudienceQuestionnaire']
    parseQuestionnaireStep:
        (step: NinchatEnvironmentConfig['preAudienceQuestionnaire'][0] & NinchatEnvironmentConfig['postAudienceQuestionnaire'][0],
             isCurrentStep: boolean, stepIndex?: number) => React.ReactElement | null
}

export const QuestionnaireLightBot = ({
    questionnaire, parseQuestionnaireStep, stepsHistory, currentStep,
}: QuestionnaireLightBotProps): React.ReactElement => {
    const embed = useContext(EmbedContext)
    const {t} = useTranslation()

    const avatarIcon = () => {
        if (embed?.lightBotAvatarIcon?.svg) {
            // eslint-disable-next-line react/no-danger
            return (
                <StyledIcon
                    aria-hidden='true'
                    css={{
                        $$height: embed.lightBotAvatarIcon.height ? `${embed.lightBotAvatarIcon.height}px` : 'auto',
                        $$width: embed.lightBotAvatarIcon.width ? `${embed.lightBotAvatarIcon.width}px` : 'auto',
                    }}
                    dangerouslySetInnerHTML={{__html: embed.lightBotAvatarIcon.svg}}
                />
            )
        } else if (embed?.lightBotAvatarIcon?.src) {
            return (
                <img
                    alt={embed.lightBotAvatarIcon.alt || ''}
                    aria-hidden='true'
                    height={embed.lightBotAvatarIcon.height ? `${embed.lightBotAvatarIcon.height}px` : 'auto'}
                    src={embed.lightBotAvatarIcon.src}
                    width={embed.lightBotAvatarIcon.width ? `${embed.lightBotAvatarIcon.width}px` : 'auto'}
                />)
        }
        return <NinchatLightBotAvatarIcon />
    }

    const renderStep = (step: number, index: number) => {
        const stepElement = parseQuestionnaireStep(questionnaire[step], stepsHistory.length - 1 !== index, index)

        if (!stepElement) {
            return null
        }

        return (
            <StyledLightBotStep key={`${step}-${index}`}>
                <StyledAvatar>{avatarIcon()} {embed?.lightBotAvatarName || t('Light Bot')}</StyledAvatar>
                {stepElement}
            </StyledLightBotStep>
        )
    }

    return (
        <StyledLightBotWrapper>
            {stepsHistory.map((step, index) => (questionnaire[step].type === 'view' || stepsHistory.length === 1 ?
                renderStep(step, index)
                : null))}

            {/* in steps history there are only view steps so if specific step is not in history, it means it's need to be rendered separately */}
            {stepsHistory[stepsHistory.length - 1] === currentStep
                ? null :
                renderStep(currentStep, stepsHistory.length)}
        </StyledLightBotWrapper>
    )
}
